module.exports = __webpack_public_path__ + "static/media/Lesson-10-29-Faith-and-the-Future.ec5fca49.pdf";